import { Store } from "@tanstack/react-store";
import { localStorage } from "../utils/local-storage";

// Storage key for recent searches
export const RECENT_SEARCHES_KEY = "recent_searches";
export const MAX_RECENT_SEARCHES = 20;

// Type for recent search item
export interface RecentSearchItem {
  term: string;
  count: number;
}

// Store for recent search items (most recent first)
export const recentSearchesStore = new Store<RecentSearchItem[]>([]);

// Load recent searches from localStorage
export const loadRecentSearches = (): void => {
  const json = localStorage?.getItem(RECENT_SEARCHES_KEY);
  if (json && json !== "undefined") {
    try {
      const arr = JSON.parse(json) as RecentSearchItem[];
      recentSearchesStore.state = arr;
    } catch (e) {
      console.error("Failed to parse recent searches:", e);
      recentSearchesStore.state = [];
    }
  }
};

// Save recent searches to localStorage
export const saveRecentSearches = (): void => {
  console.log("Saving recent searches:", recentSearchesStore.state);
  localStorage?.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearchesStore.state));
};

// Subscribe to changes and save
recentSearchesStore.subscribe(() => {
  console.log("recentSearchesStore updated");
  saveRecentSearches();
});

// Add a search term to recent searches
export const addRecentSearch = (term: string, count: number): void => {
  if (!term.trim()) return;
  recentSearchesStore.setState((prev) => {
    // Remove if already present
    const filtered = prev.filter((item) => item.term !== term);
    // Add to front
    filtered.unshift({ term, count });
    // Trim to max
    return filtered.slice(0, MAX_RECENT_SEARCHES);
  });
};

// Clear all recent searches
export const clearRecentSearches = (): void => {
  recentSearchesStore.setState(() => []);
};
